module.exports = __webpack_public_path__ + "img/1.05996b9d.png";